import { IPagination } from '@shared/models/interfaces/IPagination';
import { createAction, props } from '@ngrx/store';

export const addItems = createAction(
  '[InfiniteScroll] Add Items',
  props<{
    key: string;
    items: any[];
    pagination: IPagination;
    itemUniquePropertyKey: string;
  }>()
);

export const clearItems = createAction(
  '[InfiniteScroll] Clear Items',
  props<{ key: string }>()
);
